import { Colors } from "@auteco/theme"
import { makeStyles } from "@material-ui/core"

const useStyles = makeStyles(() => ({
    dialogContent: {
        width: 'auto',
        minWidth: '300px',
        minHeight: '300px',
        padding: '12px 24px',
        borderBottom: '2px solid #f0f0f0'
    },
    textField: {
        marginBottom: '12px'
    },
    elementsContainer: {
        maxHeight: '200px',
        overflowY: 'auto',
        border: `2px solid ${Colors.DARK_GRAY_BACKGROUND}`,
        // background: Colors.GRAY_BACKGROUND,
        borderRadius: '4px',
        '& div:last-child': {
            borderBottom: 0
        },
    },
    elemetsTitle: {
        margin: '12px 0 8px',
        textAlign: 'center',
        fontWeight: 'bold',
        color: Colors.DARK_BLUE
    },
    element: {
        width: '100%',
        padding: '12px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        borderBottom: `2px solid ${Colors.DARK_GRAY_BACKGROUND}`
    },
    elementTxt: {
        margin: 0
    },
    closeBtn: {
        width: '120px',
        margin: '12px auto'
    },
    deleteBtn: {
        width: '120px',
        backgroundColor: Colors.DARK_BLUE,
        marginRight: '12px',
        '&:hover': {
            backgroundColor: Colors.DARK_BLUE,
        }
    }
}))

export default useStyles